unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Imaging.jpeg, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons, WEBLib.Grids, WEBLib.WebCtrls;

type
  TForm1 = class(TForm)
    WebResponsiveGridPanel2: TResponsiveGridPanel;
    WebResponsiveGridPanel3: TResponsiveGridPanel;
    WebResponsiveGridPanel4: TResponsiveGridPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    WebLabel1: TLabel;
    WebSpeedButton2: TSpeedButton;
    WebLabel2: TLabel;
    WebSpeedButton3: TSpeedButton;
    WebLabel3: TLabel;
    WebSpeedButton4: TSpeedButton;
    WebLabel4: TLabel;
    WebSpeedButton5: TSpeedButton;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebSpeedButton6: TSpeedButton;
    WebLabel7: TLabel;
    WebSpeedButton7: TSpeedButton;
    WebLabel8: TLabel;
    WebSpeedButton9: TSpeedButton;
    WebLabel9: TLabel;
    WebSpeedButton10: TSpeedButton;
    WebLabel10: TLabel;
    WebResponsiveGridPanel5: TResponsiveGridPanel;
    WebResponsiveGridPanel1: TResponsiveGridPanel;
    WebImageControl1: TImageControl;
    WebResponsiveGridPanel7: TResponsiveGridPanel;
    WebResponsiveGridPanel6: TResponsiveGridPanel;
    WebSpeedButton11: TSpeedButton;
    WebResponsiveGridPanel8: TResponsiveGridPanel;
    WebLabel11: TLabel;
    WB1: TBrowserControl;
    WebSpeedButton12: TSpeedButton;
    WebResponsiveGridPanel10: TResponsiveGridPanel;
    WebResponsiveGridPanel13: TResponsiveGridPanel;
    WebPanel1: TPanel;
    WebSpeedButton13: TSpeedButton;
    WebSpeedButton14: TSpeedButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormEnter(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
  private
    { Private declarations }
  public
     x,y: integer;
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;
  x,y: integer;

implementation

{$R *.dfm}

procedure TForm1.WebFormCreate(Sender: TObject);
begin
x:=window.screen.width;
y:=window.screen.height;

if x>900 then
begin
 webresponsivegridpanel10.Height:=2;
end;
if x<901 then
begin
 weblabel11.Font.Size:=8;
end;



//weblabel4.Caption:='Miudezas / Festas / Guarda-chuvas'+CHR(13)+
//'Caça-Pesca / Elét./ Hid.';
//weblabel5.caption:='Aromatizantes / Utilidades Casa /'+chr(13)+
//'Decoração / Limpeza';
//weblabel7.Caption:='Utilidades Vidro /'+CHR(13)+
//'Porcelana / Aluminio';
//WEBLABEL8.Caption:='Porta Latas /'+CHR(13)+'Porta Garrafas / cxs.Térmicas';
//WEBLABEL9.Caption:='Flores Artificiais /'+CHR(13)+
//'Vasos / Arranjos / Árvores';
//WEBLABEL10.Caption:='Toalhas / Panos de Copa /'+CHR(13)+'Panos de chão';


end;

procedure TForm1.WebFormEnter(Sender: TObject);
begin
//weblabel4.Caption:='Miudezas / Festas / Guarda-chuvas'+CHR(13)+
//'Caça-Pesca / Elét./ Hid.';
//weblabel5.caption:='Aromatizantes / Utilidades Casa /'+chr(13)+
//'Decoração / Limpeza';
//weblabel7.Caption:='Utilidades Vidro /'+CHR(13)+
//'Porcelana / Aluminio';
//WEBLABEL8.Caption:='Porta Latas /'+CHR(13)+'Porta Garrafas / cxs.Térmicas';
//WEBLABEL9.Caption:='Flores Artificiais /'+CHR(13)+
//'Vasos / Arranjos / Árvores';
//WEBLABEL10.Caption:='Toalhas / Panos de Copa /'+CHR(13)+'Panos de chão';

end;

procedure TForm1.WebSpeedButton10Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat15.pdf';
// WINDOW.location.reload(TRUE);
 if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat15.pdf';
 if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat15.pdf');
end;

procedure TForm1.WebSpeedButton11Click(Sender: TObject);
begin
 application.Navigate('https://api.whatsapp.com/send/?phone=5551993503505');
end;

procedure TForm1.WebSpeedButton12Click(Sender: TObject);
begin
 APPLICATION.download('https://www.vaat.com.br/ba/VAAT131.apk');
end;

procedure TForm1.WebSpeedButton1Click(Sender: TObject);
//var
//x,y: integer;
begin
//  x:=window.screen.width;
//  y:=window.screen.height;
//  weblabel11.Caption:='numero de pixes: '+inttostr(x);
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat1.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat1.pdf');
//APPLICATION.download('https://www.pro.varisco.com.br/catalogos1/cat1.pdf');
end;

procedure TForm1.WebSpeedButton2Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat2.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat2.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat2.pdf');

end;

procedure TForm1.WebSpeedButton3Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat3.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat3.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat3.pdf');
end;

procedure TForm1.WebSpeedButton4Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat4.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat4.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat4.pdf');
end;

procedure TForm1.WebSpeedButton5Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat5.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat5.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat5.pdf');
end;

procedure TForm1.WebSpeedButton6Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat7.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat7.pdf';
if x<901 then
//application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat7.pdf');
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat7.pdf',
ntblank);
end;

procedure TForm1.WebSpeedButton7Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat8.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat8.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat8.pdf');
end;

procedure TForm1.WebSpeedButton8Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat6.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat6.pdf';
if x<901 then
//application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat6.pdf');
application.Download('https://www.pro.varisco.com.br/catalogos1/cat6.pdf');
end;

procedure TForm1.WebSpeedButton9Click(Sender: TObject);
begin
// wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat9.pdf';
if x>900 then wb1.URL:='https://www.pro.varisco.com.br/catalogos1/cat9.pdf';
if x<901 then
application.Navigate('https://www.pro.varisco.com.br/catalogos1/cat9.pdf');
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebResponsiveGridPanel2 := TResponsiveGridPanel.Create(Self);
  WebResponsiveGridPanel1 := TResponsiveGridPanel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebResponsiveGridPanel7 := TResponsiveGridPanel.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  WebResponsiveGridPanel6 := TResponsiveGridPanel.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebResponsiveGridPanel3 := TResponsiveGridPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebResponsiveGridPanel4 := TResponsiveGridPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebResponsiveGridPanel5 := TResponsiveGridPanel.Create(Self);
  WB1 := TBrowserControl.Create(Self);
  WebResponsiveGridPanel8 := TResponsiveGridPanel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebResponsiveGridPanel10 := TResponsiveGridPanel.Create(Self);
  WebResponsiveGridPanel13 := TResponsiveGridPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebSpeedButton14 := TSpeedButton.Create(Self);

  WebResponsiveGridPanel2.BeforeLoadDFMValues;
  WebResponsiveGridPanel1.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebResponsiveGridPanel7.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  WebResponsiveGridPanel6.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebResponsiveGridPanel3.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebResponsiveGridPanel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebResponsiveGridPanel5.BeforeLoadDFMValues;
  WB1.BeforeLoadDFMValues;
  WebResponsiveGridPanel8.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebResponsiveGridPanel10.BeforeLoadDFMValues;
  WebResponsiveGridPanel13.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebSpeedButton14.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 837;
    Height := 619;
    Align := alClient;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnEnter', 'WebFormEnter');
    WebResponsiveGridPanel2.SetParentComponent(Self);
    WebResponsiveGridPanel2.Name := 'WebResponsiveGridPanel2';
    WebResponsiveGridPanel2.Left := 0;
    WebResponsiveGridPanel2.Top := 0;
    WebResponsiveGridPanel2.Width := 837;
    WebResponsiveGridPanel2.Height := 105;
    WebResponsiveGridPanel2.Align := alTop;
    WebResponsiveGridPanel2.ChildOrder := 1;
    WebResponsiveGridPanel2.ControlCollection.Clear;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebResponsiveGridPanel1;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebResponsiveGridPanel7;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebResponsiveGridPanel6;
    end;
    WebResponsiveGridPanel2.Color := clMoneyGreen;
    WebResponsiveGridPanel2.Layout.Clear;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebResponsiveGridPanel1.SetParentComponent(WebResponsiveGridPanel2);
    WebResponsiveGridPanel1.Name := 'WebResponsiveGridPanel1';
    WebResponsiveGridPanel1.Left := 0;
    WebResponsiveGridPanel1.Top := 0;
    WebResponsiveGridPanel1.Width := 337;
    WebResponsiveGridPanel1.Height := 83;
    WebResponsiveGridPanel1.Align := alLeft;
    WebResponsiveGridPanel1.ControlCollection.Clear;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebImageControl1;
    end;
    WebResponsiveGridPanel1.Color := clWhite;
    WebResponsiveGridPanel1.Layout.Clear;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebImageControl1.SetParentComponent(WebResponsiveGridPanel1);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 0;
    WebImageControl1.Width := 297;
    WebImageControl1.Height := 80;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.Align := alClient;
    WebImageControl1.Picture.LoadFromFile('Unit1.WebResponsiveGridPanel1.WebImageControl1.Picture.jpg');
    WebResponsiveGridPanel7.SetParentComponent(WebResponsiveGridPanel2);
    WebResponsiveGridPanel7.Name := 'WebResponsiveGridPanel7';
    WebResponsiveGridPanel7.Left := 279;
    WebResponsiveGridPanel7.Top := 0;
    WebResponsiveGridPanel7.Width := 266;
    WebResponsiveGridPanel7.Height := 100;
    WebResponsiveGridPanel7.Margins.Left := 10;
    WebResponsiveGridPanel7.Margins.Right := 10;
    WebResponsiveGridPanel7.Align := alRight;
    WebResponsiveGridPanel7.ChildOrder := 2;
    WebResponsiveGridPanel7.ControlCollection.Clear;
    with WebResponsiveGridPanel7.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton12;
    end;
    WebResponsiveGridPanel7.Color := clMoneyGreen;
    WebResponsiveGridPanel7.Layout.Clear;
    with WebResponsiveGridPanel7.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel7.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel7.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel7.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebSpeedButton12.SetParentComponent(WebResponsiveGridPanel7);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 0;
    WebSpeedButton12.Top := 0;
    WebSpeedButton12.Width := 265;
    WebSpeedButton12.Height := 99;
    WebSpeedButton12.Margins.Left := 1;
    WebSpeedButton12.Margins.Top := 1;
    WebSpeedButton12.Margins.Right := 1;
    WebSpeedButton12.Margins.Bottom := 1;
    WebSpeedButton12.Align := alClient;
    WebSpeedButton12.Color := clMoneyGreen;
    WebSpeedButton12.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel7.WebSpeedButton12.Glyph.jpg');
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.Layout := blGlyphRight;
    WebSpeedButton12.TabOrder := 0;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    WebResponsiveGridPanel6.SetParentComponent(WebResponsiveGridPanel2);
    WebResponsiveGridPanel6.Name := 'WebResponsiveGridPanel6';
    WebResponsiveGridPanel6.Left := 558;
    WebResponsiveGridPanel6.Top := 0;
    WebResponsiveGridPanel6.Width := 290;
    WebResponsiveGridPanel6.Height := 120;
    WebResponsiveGridPanel6.Margins.Left := 10;
    WebResponsiveGridPanel6.Margins.Right := 10;
    WebResponsiveGridPanel6.Align := alRight;
    WebResponsiveGridPanel6.ChildOrder := 2;
    WebResponsiveGridPanel6.ControlCollection.Clear;
    with WebResponsiveGridPanel6.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton11;
    end;
    WebResponsiveGridPanel6.Color := clMoneyGreen;
    WebResponsiveGridPanel6.Layout.Clear;
    with WebResponsiveGridPanel6.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel6.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel6.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel6.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebSpeedButton11.SetParentComponent(WebResponsiveGridPanel6);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 0;
    WebSpeedButton11.Top := 0;
    WebSpeedButton11.Width := 233;
    WebSpeedButton11.Height := 99;
    WebSpeedButton11.Margins.Left := 1;
    WebSpeedButton11.Margins.Top := 1;
    WebSpeedButton11.Margins.Right := 1;
    WebSpeedButton11.Margins.Bottom := 1;
    WebSpeedButton11.Align := alClient;
    WebSpeedButton11.Caption := 'Nos chame no Whats';
    WebSpeedButton11.Color := clMoneyGreen;
    WebSpeedButton11.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel6.WebSpeedButton11.Glyph.jpg');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.Layout := blGlyphTop;
    WebSpeedButton11.TabOrder := 0;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebResponsiveGridPanel3.SetParentComponent(Self);
    WebResponsiveGridPanel3.Name := 'WebResponsiveGridPanel3';
    WebResponsiveGridPanel3.Left := 0;
    WebResponsiveGridPanel3.Top := 244;
    WebResponsiveGridPanel3.Width := 177;
    WebResponsiveGridPanel3.Height := 375;
    WebResponsiveGridPanel3.Margins.Left := 20;
    WebResponsiveGridPanel3.Align := alLeft;
    WebResponsiveGridPanel3.ChildOrder := 2;
    WebResponsiveGridPanel3.ControlCollection.Clear;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton1;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel1;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton2;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel2;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton3;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel3;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton4;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel4;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton5;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel5;
    end;
    WebResponsiveGridPanel3.Color := clMoneyGreen;
    WebResponsiveGridPanel3.Layout.Clear;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Width := 0;
    end;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Width := 0;
    end;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Width := 0;
    end;
    WebLabel1.SetParentComponent(WebResponsiveGridPanel3);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 65;
    WebLabel1.Width := 75;
    WebLabel1.Height := 13;
    WebLabel1.Margins.Left := 20;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Anchors := [];
    WebLabel1.Caption := 'Material Escolar';
    WebLabel1.Color := clMoneyGreen;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WordWrap := True;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebResponsiveGridPanel3);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 143;
    WebLabel2.Width := 111;
    WebLabel2.Height := 13;
    WebLabel2.Margins.Left := 20;
    WebLabel2.Anchors := [];
    WebLabel2.Caption := 'Papelaria / Embalagens';
    WebLabel2.Color := clMoneyGreen;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WordWrap := True;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebResponsiveGridPanel3);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 221;
    WebLabel3.Width := 145;
    WebLabel3.Height := 13;
    WebLabel3.Margins.Left := 20;
    WebLabel3.Anchors := [];
    WebLabel3.Caption := 'Higiene / Prim.Socorros / Beb'#234;
    WebLabel3.Color := clMoneyGreen;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WordWrap := True;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebResponsiveGridPanel3);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 299;
    WebLabel4.Width := 169;
    WebLabel4.Height := 26;
    WebLabel4.Margins.Left := 20;
    WebLabel4.Anchors := [];
    WebLabel4.Caption := 'Miudezas / Festas / Guarda-chuvas / Ca'#231'a e Pesca / El'#233't. / Hid.';
    WebLabel4.Color := clMoneyGreen;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WordWrap := True;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebResponsiveGridPanel3);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 390;
    WebLabel5.Width := 152;
    WebLabel5.Height := 26;
    WebLabel5.Margins.Left := 20;
    WebLabel5.Anchors := [];
    WebLabel5.Caption := 'Aromatizantes / Utilidades Casa / Decora'#231#227'o / Limpeza';
    WebLabel5.Color := clMoneyGreen;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WordWrap := True;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(WebResponsiveGridPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 0;
    WebSpeedButton1.Top := 0;
    WebSpeedButton1.Width := 150;
    WebSpeedButton1.Height := 65;
    WebSpeedButton1.Margins.Left := 20;
    WebSpeedButton1.Caption := 'Varisco Atacado';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel3.WebSpeedButton1.Glyph.jpg');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebResponsiveGridPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 0;
    WebSpeedButton2.Top := 78;
    WebSpeedButton2.Width := 150;
    WebSpeedButton2.Height := 65;
    WebSpeedButton2.Margins.Left := 20;
    WebSpeedButton2.Anchors := [];
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel3.WebSpeedButton2.Glyph.jpg');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebResponsiveGridPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 0;
    WebSpeedButton3.Top := 156;
    WebSpeedButton3.Width := 150;
    WebSpeedButton3.Height := 65;
    WebSpeedButton3.Margins.Left := 20;
    WebSpeedButton3.Anchors := [];
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel3.WebSpeedButton3.Glyph.jpg');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebResponsiveGridPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 0;
    WebSpeedButton4.Top := 234;
    WebSpeedButton4.Width := 150;
    WebSpeedButton4.Height := 65;
    WebSpeedButton4.Margins.Left := 20;
    WebSpeedButton4.Anchors := [];
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel3.WebSpeedButton4.Glyph.jpg');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebResponsiveGridPanel3);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 0;
    WebSpeedButton5.Top := 325;
    WebSpeedButton5.Width := 150;
    WebSpeedButton5.Height := 65;
    WebSpeedButton5.Anchors := [];
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel3.WebSpeedButton5.Glyph.jpg');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebResponsiveGridPanel4.SetParentComponent(Self);
    WebResponsiveGridPanel4.Name := 'WebResponsiveGridPanel4';
    WebResponsiveGridPanel4.Left := 177;
    WebResponsiveGridPanel4.Top := 244;
    WebResponsiveGridPanel4.Width := 184;
    WebResponsiveGridPanel4.Height := 375;
    WebResponsiveGridPanel4.Align := alLeft;
    WebResponsiveGridPanel4.ChildOrder := 3;
    WebResponsiveGridPanel4.ControlCollection.Clear;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton8;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel6;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton6;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel7;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton7;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel8;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton9;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel9;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSpeedButton10;
    end;
    with WebResponsiveGridPanel4.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel10;
    end;
    WebResponsiveGridPanel4.Color := clMoneyGreen;
    WebResponsiveGridPanel4.Layout.Clear;
    with WebResponsiveGridPanel4.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel4.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel4.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel4.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebLabel6.SetParentComponent(WebResponsiveGridPanel4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 64;
    WebLabel6.Width := 90;
    WebLabel6.Height := 13;
    WebLabel6.Anchors := [];
    WebLabel6.Caption := 'Utilidades Pl'#225'sticas';
    WebLabel6.Color := clMoneyGreen;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WordWrap := True;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebResponsiveGridPanel4);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 0;
    WebLabel7.Top := 142;
    WebLabel7.Width := 143;
    WebLabel7.Height := 26;
    WebLabel7.Anchors := [];
    WebLabel7.Caption := 'Utilidades Vidro / Porcelana  / Aluminio ';
    WebLabel7.Color := clMoneyGreen;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WordWrap := True;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebResponsiveGridPanel4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 0;
    WebLabel8.Top := 233;
    WebLabel8.Width := 171;
    WebLabel8.Height := 26;
    WebLabel8.Anchors := [];
    WebLabel8.Caption := 'Porta Latas / Porta Garrafas / Cxs. T'#233'rmicas';
    WebLabel8.Color := clMoneyGreen;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WordWrap := True;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebResponsiveGridPanel4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 0;
    WebLabel9.Top := 324;
    WebLabel9.Width := 174;
    WebLabel9.Height := 26;
    WebLabel9.Anchors := [];
    WebLabel9.Caption := 'Flores Artificiais / Vasos / Arranjos / '#193'rvores';
    WebLabel9.Color := clMoneyGreen;
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WordWrap := True;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebResponsiveGridPanel4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 0;
    WebLabel10.Top := 415;
    WebLabel10.Width := 176;
    WebLabel10.Height := 26;
    WebLabel10.Anchors := [];
    WebLabel10.Caption := 'Toalhas / Panos de Copa / Panos de ch'#227'o';
    WebLabel10.Color := clMoneyGreen;
    WebLabel10.HeightPercent := 20.000000000000000000;
    WebLabel10.WordWrap := True;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebResponsiveGridPanel4);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 0;
    WebSpeedButton8.Top := 0;
    WebSpeedButton8.Width := 150;
    WebSpeedButton8.Height := 64;
    WebSpeedButton8.Anchors := [];
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel4.WebSpeedButton8.Glyph.jpg');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 0;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton6.SetParentComponent(WebResponsiveGridPanel4);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 0;
    WebSpeedButton6.Top := 77;
    WebSpeedButton6.Width := 150;
    WebSpeedButton6.Height := 65;
    WebSpeedButton6.Anchors := [];
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel4.WebSpeedButton6.Glyph.jpg');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 1;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebResponsiveGridPanel4);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 0;
    WebSpeedButton7.Top := 168;
    WebSpeedButton7.Width := 150;
    WebSpeedButton7.Height := 65;
    WebSpeedButton7.Anchors := [];
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel4.WebSpeedButton7.Glyph.jpg');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 2;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton9.SetParentComponent(WebResponsiveGridPanel4);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 0;
    WebSpeedButton9.Top := 259;
    WebSpeedButton9.Width := 150;
    WebSpeedButton9.Height := 65;
    WebSpeedButton9.Anchors := [];
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel4.WebSpeedButton9.Glyph.jpg');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 3;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(WebResponsiveGridPanel4);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 0;
    WebSpeedButton10.Top := 350;
    WebSpeedButton10.Width := 150;
    WebSpeedButton10.Height := 65;
    WebSpeedButton10.Anchors := [];
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('Unit1.WebResponsiveGridPanel4.WebSpeedButton10.Glyph.jpg');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.TabOrder := 4;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebResponsiveGridPanel5.SetParentComponent(Self);
    WebResponsiveGridPanel5.Name := 'WebResponsiveGridPanel5';
    WebResponsiveGridPanel5.Left := 361;
    WebResponsiveGridPanel5.Top := 244;
    WebResponsiveGridPanel5.Width := 476;
    WebResponsiveGridPanel5.Height := 375;
    WebResponsiveGridPanel5.Align := alClient;
    WebResponsiveGridPanel5.ChildOrder := 4;
    WebResponsiveGridPanel5.ControlCollection.Clear;
    with WebResponsiveGridPanel5.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WB1;
    end;
    WebResponsiveGridPanel5.Color := clMoneyGreen;
    WebResponsiveGridPanel5.Layout.Clear;
    with WebResponsiveGridPanel5.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel5.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel5.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel5.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WB1.SetParentComponent(WebResponsiveGridPanel5);
    WB1.Name := 'WB1';
    WB1.Left := 0;
    WB1.Top := 0;
    WB1.Width := 480;
    WB1.Height := 360;
    WB1.Align := alClient;
    WB1.Sandbox := [];
    WebResponsiveGridPanel8.SetParentComponent(Self);
    WebResponsiveGridPanel8.Name := 'WebResponsiveGridPanel8';
    WebResponsiveGridPanel8.Left := 0;
    WebResponsiveGridPanel8.Top := 218;
    WebResponsiveGridPanel8.Width := 837;
    WebResponsiveGridPanel8.Height := 26;
    WebResponsiveGridPanel8.Align := alTop;
    WebResponsiveGridPanel8.ChildOrder := 4;
    WebResponsiveGridPanel8.ControlCollection.Clear;
    with WebResponsiveGridPanel8.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabel11;
    end;
    WebResponsiveGridPanel8.Color := clMoneyGreen;
    WebResponsiveGridPanel8.Layout.Clear;
    with WebResponsiveGridPanel8.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel8.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel8.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel8.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebLabel11.SetParentComponent(WebResponsiveGridPanel8);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 0;
    WebLabel11.Top := 0;
    WebLabel11.Width := 803;
    WebLabel11.Height := 19;
    WebLabel11.Align := alClient;
    WebLabel11.Anchors := [akBottom];
    WebLabel11.Caption := 'Conhe'#231'a nossa linha de produtos     -  Clique na linha desejada e visualize os produtos com o pre'#231'o';
    WebLabel11.Color := clMoneyGreen;
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -16;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebResponsiveGridPanel10.SetParentComponent(Self);
    WebResponsiveGridPanel10.Name := 'WebResponsiveGridPanel10';
    WebResponsiveGridPanel10.Left := 0;
    WebResponsiveGridPanel10.Top := 105;
    WebResponsiveGridPanel10.Width := 837;
    WebResponsiveGridPanel10.Height := 113;
    WebResponsiveGridPanel10.Align := alTop;
    WebResponsiveGridPanel10.ChildOrder := 1;
    WebResponsiveGridPanel10.ControlCollection.Clear;
    with WebResponsiveGridPanel10.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebResponsiveGridPanel13;
    end;
    WebResponsiveGridPanel10.Color := clMoneyGreen;
    WebResponsiveGridPanel10.Layout.Clear;
    with WebResponsiveGridPanel10.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel10.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel10.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel10.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebResponsiveGridPanel13.SetParentComponent(WebResponsiveGridPanel10);
    WebResponsiveGridPanel13.Name := 'WebResponsiveGridPanel13';
    WebResponsiveGridPanel13.Left := 0;
    WebResponsiveGridPanel13.Top := 0;
    WebResponsiveGridPanel13.Width := 433;
    WebResponsiveGridPanel13.Height := 113;
    WebResponsiveGridPanel13.Margins.Left := 10;
    WebResponsiveGridPanel13.Margins.Right := 10;
    WebResponsiveGridPanel13.Align := alRight;
    WebResponsiveGridPanel13.ChildOrder := 2;
    WebResponsiveGridPanel13.ControlCollection.Clear;
    with WebResponsiveGridPanel13.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanel1;
    end;
    WebResponsiveGridPanel13.Color := clMoneyGreen;
    WebResponsiveGridPanel13.Layout.Clear;
    with WebResponsiveGridPanel13.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with WebResponsiveGridPanel13.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 768;
    end;
    with WebResponsiveGridPanel13.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 1fr 1fr';
      Width := 991;
    end;
    with WebResponsiveGridPanel13.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 1fr 1fr 1fr';
      Width := 1199;
    end;
    WebPanel1.SetParentComponent(WebResponsiveGridPanel13);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 358;
    WebPanel1.Height := 113;
    WebPanel1.Align := alClient;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.ChildOrder := 2;
    WebSpeedButton13.SetParentComponent(WebPanel1);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 0;
    WebSpeedButton13.Top := 0;
    WebSpeedButton13.Width := 193;
    WebSpeedButton13.Height := 113;
    WebSpeedButton13.Margins.Left := 1;
    WebSpeedButton13.Margins.Top := 1;
    WebSpeedButton13.Margins.Right := 1;
    WebSpeedButton13.Margins.Bottom := 1;
    WebSpeedButton13.Align := alLeft;
    WebSpeedButton13.Color := clMoneyGreen;
    WebSpeedButton13.Glyph.LoadFromFile('Unit1.WebPanel1.WebSpeedButton13.Glyph.jpg');
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.Layout := blGlyphRight;
    WebSpeedButton13.TabOrder := 0;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton13, Self, 'OnClick', 'WebSpeedButton12Click');
    WebSpeedButton14.SetParentComponent(WebPanel1);
    WebSpeedButton14.Name := 'WebSpeedButton14';
    WebSpeedButton14.Left := 193;
    WebSpeedButton14.Top := 0;
    WebSpeedButton14.Width := 165;
    WebSpeedButton14.Height := 113;
    WebSpeedButton14.Margins.Left := 1;
    WebSpeedButton14.Margins.Top := 1;
    WebSpeedButton14.Margins.Right := 1;
    WebSpeedButton14.Margins.Bottom := 1;
    WebSpeedButton14.Align := alClient;
    WebSpeedButton14.Caption := 'Nos chame no Whats';
    WebSpeedButton14.Color := clMoneyGreen;
    WebSpeedButton14.Glyph.LoadFromFile('Unit1.WebPanel1.WebSpeedButton14.Glyph.jpg');
    WebSpeedButton14.HeightPercent := 100.000000000000000000;
    WebSpeedButton14.Layout := blGlyphTop;
    WebSpeedButton14.TabOrder := 1;
    WebSpeedButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton14, Self, 'OnClick', 'WebSpeedButton11Click');
  finally
    WebResponsiveGridPanel2.AfterLoadDFMValues;
    WebResponsiveGridPanel1.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebResponsiveGridPanel7.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    WebResponsiveGridPanel6.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebResponsiveGridPanel3.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebResponsiveGridPanel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebResponsiveGridPanel5.AfterLoadDFMValues;
    WB1.AfterLoadDFMValues;
    WebResponsiveGridPanel8.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebResponsiveGridPanel10.AfterLoadDFMValues;
    WebResponsiveGridPanel13.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebSpeedButton14.AfterLoadDFMValues;
  end;
end;

end.
